// Experiment
export const getTakeoverExperiment = (state: Record<string, any>) =>
  state.experiments.takeover.experiment.data;

export const getTakeoverExperimentLocale = (state: Record<string, any>) =>
  state.experiments.takeover.experiment.currentLocale;

export const getTakeoverExperimentName = (state: Record<string, any>) =>
  getTakeoverExperiment(state).name;
export const getTakeoverExperimentId = (state: Record<string, any>) =>
  getTakeoverExperiment(state).id;
export const getTakeoverExperimentType = (state: Record<string, any>) =>
  getTakeoverExperiment(state).type;

// Campaign
export const getTakeoverCampaign = (state: Record<string, any>) =>
  getTakeoverExperiment(state).campaign;
export const getTakeoverCampaignName = (state: Record<string, any>) =>
  getTakeoverCampaign(state).name;
